import DateExtended from "serviceJs/date.service.ts";

export default function formatDates(date, duration, showDuration) {
    return new DateExtended(date)
        .format("[dddd]. [D]/[M]/[YY], " + (showDuration && duration.length ? duration + "," : "") + " [HH].[mm]")
        .replace(/(^\w)/g, (item) => {
            return item.toUpperCase();
        });
}

window.formatDates = formatDates;
